import React from 'react';
import { ProviderProjectView } from './ProviderProjectView';

export function LawyerProjectView() {
  return <ProviderProjectView providerType="lawyer" />;
}
